import ajax from "./ajax";

export const getPaymetMethods = () => {
  return ajax("/invoices/payment_methods", { server: "python" });
};

export const getPaymetMethodsForUser = (userId) => {
  return ajax("/invoices/user_payment_methods", {
    server: "python",
    query: { userId },
  });
};

export const setDefaultPaymentMethod = (data) => {
  return ajax("/invoices/payment_methods", {
    server: "python",
    method: "PUT",
    data,
  });
};

export const deletePaymentMethod = (query) => {
  return ajax(`/invoices/payment_methods`, {
    server: "python",
    method: "DELETE",
    query,
  });
};

export const connectAccount = (country = "US") => {
  return ajax("/v2/stripe/connect-account", {
    server: "python",
    query: { country },
  });
};

/**
 * PAY-3: Stripe Connect OAuth (connect the Stripe account they already have).
 * Returns { url } to send the browser to; Stripe redirects back to
 * /popup-store-payouts?connect=return&oauth=connected|error.
 */
export const startConnectOauth = (locationId) => {
  return ajax("/v2/stripe/connect/oauth/start", {
    server: "python",
    query: locationId ? { locationId } : undefined,
  });
};

export const getConnectStatus = () => {
  return ajax("/v2/stripe/connect-status", {
    server: "python",
  });
};

export const detachConnectAccount = () => {
  return ajax("/v2/stripe/connect-account/detach", {
    server: "python",
    method: "POST",
  });
};
